import {useEffect, useRef, useState} from "react";

export const Switch = (props) => {
    const [checked, setChecked] = useState(props.checked || false);
    const id = props.id || `switch-${Math.random().toString(36).substring(2, 9)}`;
    const input = useRef();

    useEffect(() => {
        if (input.current) {
            input.current.checked = checked;
        }
    }, [checked]);

    useEffect(() => {
        setChecked(props.checked);
    }, [props.checked]);

    const handleChange = (e) => {
        setChecked(e.target.checked);
        props.onCheck?.(e.target.checked);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const newState = !checked;
            setChecked(newState);
            props.onCheck?.(newState);
        }
    };

    return (
        <div className="switch">
            <input
                ref={input}
                type="checkbox"
                id={id}
                checked={checked}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                aria-checked={checked}
                role="switch"
            />
            <div className="switch-icon" aria-hidden="true"></div>
            <label htmlFor={id}>{props.children}</label>
        </div>
    );
}